<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Semanas</h4>
    <hr />

    <DataTable
      :data="semanas"
      :columns="columnas"
      idField="idSemana"
      mensajeVacio="No hay semanas registradas."
      :mostrarBotonNuevo="esAdmin"
      :mostrarEditar="esAdmin"
      :mostrarVer="false"
      :mostrarEliminar="esAdmin"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idSemana)"
      @delete="row => deleteSemana(row.idSemana)"
    >
      <!-- Búsqueda por número de semana en la barra de acciones -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar semana..."
            style="width:200px"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>

      <!-- Celda personalizada: fechaDesde formateada -->
      <template #cell-fechaDesde="{ row }">
        {{ getFormattedDate(row.fechaDesde) }}
      </template>

      <!-- Celda personalizada: fechaHasta formateada -->
      <template #cell-fechaHasta="{ row }">
        {{ getFormattedDate(row.fechaHasta) }}
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">ID</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoSemana.idSemana"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Fecha Desde -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha Desde</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      v-model="datoSemana.fechaDesde"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Fecha Hasta -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha Hasta</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      v-model="datoSemana.fechaHasta"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarSemana"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="guardarEditSemana"
              v-if=" btnEditar && esAdmin "
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat      from "@/modules/dateFormat.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "SemanaList",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      semanas:        [],
      datoSemana:     {},
      nombreBusqueda: "",
      titulo:         "",
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,
      idPerfil:       0,
    };
  },

  computed: {
    esAdmin() {
      return Number(this.idPerfil) === 1;
    },

    columnas() {
      return [
        // fechaDesde y fechaHasta usan slots #cell-* para formateo
        { label: "Fecha Desde",    field: "fechaDesde"   },
        { label: "Fecha Hasta",    field: "fechaHasta"   },
        { label: "N.° Semana",     field: "numeroSemana" },
      ];
    },
  },

  mounted() {
    this.idPerfil = window.sessionStorage.getItem("idPerfil");
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
  },

  methods: {
    // ── Utilidades ────────────────────────────────────────────
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },

    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwsemanas")
        .then(r => { this.semanas = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar semanas:", e));
    },

    // Filtro en frontend por número de semana o fechas
    getDataNombre() {
      const texto = this.nombreBusqueda.trim().toLowerCase();
      if (!texto) { this.getData(); return; }
      api.get("/vwsemanas")
        .then(r => {
          this.semanas = (r.data ?? []).filter(s =>
            String(s.numeroSemana ?? "").toLowerCase().includes(texto) ||
            (s.fechaDesde ?? "").slice(0, 10).includes(texto) ||
            (s.fechaHasta ?? "").slice(0, 10).includes(texto)
          );
        })
        .catch(e => console.error("Error al buscar semana:", e));
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoSemana,
        ["fechaDesde", "fechaHasta"],
        ["Fecha Desde", "Fecha Hasta"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarSemana() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/semanas", this.datoSemana);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Semana creada exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async guardarEditSemana() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/semanas", this.datoSemana);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Semana actualizada exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteSemana(idSemana) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar semana?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/semanas/" + idSemana);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoSemana  = {};
      this.titulo      = "Crear Semana";
      this.btnCrear    = true;
      this.btnEditar   = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idSemana) {
      this.modalWindow = true;
      this.titulo      = "Editar Semana";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp      = await api.get("/vwsemanas/" + idSemana);
        this.datoSemana = resp.data;
        // Normalizar fechas al formato yyyy-MM-dd para input type="date"
        if (this.datoSemana.fechaDesde)
          this.datoSemana.fechaDesde = this.datoSemana.fechaDesde.slice(0, 10);
        if (this.datoSemana.fechaHasta)
          this.datoSemana.fechaHasta = this.datoSemana.fechaHasta.slice(0, 10);
      } catch (e) {
        console.error("Error al cargar semana:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },
  },
};
</script>